/**
 * for showing error
 */
const TextError = ({ children }) => {
  return <div style={{ color: "red", fontSize: "16px" }}>{children}</div>;
};

export default TextError;
